<template>
    <div class="card" style="margin-bottom: 5px;" >
        <lot-header :bid="bid"></lot-header>
        <div class="card-content" style="padding: 5px !important;">
            <lot-content :bid="bid"></lot-content>
        </div>
        <bid-modal :bid="bid" v-if="isActive"></bid-modal>
    </div>
</template>

<script>
    import lotHeader from './Headers/LotHeader.vue'
    import lotContent from './Content/LotContent.vue'
    import BidModal from '../Auctions/Lot/BidModal.vue'
    export default {
        components: {
            lotHeader: lotHeader,
            lotContent: lotContent,
            bidModal: BidModal
        },
        props: ['bid'],
        computed: {
            isActive: function () {
                return this.$store.getters.getBidModalStatus(this.bid.lot_id)
            },
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Card/LotLayout.vue